<script setup>
import { computed } from 'vue'
import { RouterLink } from 'vue-router'
import IconBase from '@/components/icon/IconBase.vue'
import IconChevronLeft from '@/components/icon/IconChevronLeft.vue'

const props = defineProps({
	to: {
		type: [String, Object],
		default: undefined,
	},
	title: {
		type: String,
		default: 'Back',
	},
	ariaLabel: {
		type: String,
		default: '',
	},
})

const isLink = computed(() => !!props.to)
const rootBind = computed(() => (isLink.value ? { to: props.to } : { type: 'button' }))
const buttonClass = 'shrink-0 size-[26px] inline-flex items-center justify-center rounded-md bg-surface-2 text-surface-text-2 hover:text-white hover:bg-surface-3 hover:no-underline transition-colors'
</script>

<template>
	<component
		:is="isLink ? RouterLink : 'button'"
		v-bind="rootBind"
		:title="title"
		:aria-label="ariaLabel || title"
		:class="buttonClass"
	>
		<icon-base fill="none">
			<icon-chevron-left />
		</icon-base>
	</component>
</template>
